<template>
  <div v-show="isLoaded" class="main-container">
    <Classify
      class="classify"
      :class="{
        'classify-top': !$route.query.recommend && !$route.query.keywords,
      }"
      :items="classifyItems"
      @change="onClassifyChange"
    >
      <template v-slot:date>
        <div class="class-date">
          <span class="label">上课时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            size="small"
            value-format="timestamp"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="changDate"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </div>
      </template>
    </Classify>
    <List
      class="list"
      ref="list"
      url="/api/app/inviteTeacher"
      :search="params"
      :limit="10"
      :alwaysShowPager="true"
      @page-load="onListLoad"
    >
      <template v-slot="{ list }">
        <div class="teacher-list clearfix">
          <div class="teacher" v-for="item in list" :key="item.id">
            <div class="avatar-wrap">
              <img class="avatar" :src="item.photo" />
              <div class="tag"></div>
            </div>
            <div class="right">
              <div class="name-wrap">
                <span class="name">{{ item.teacher_name }}</span>
              </div>
              <div class="marketing_language">
                {{ item.marketing_language }}
              </div>
              <div class="career">
                <span class="class-time">{{ item.real_teach_age }}年教龄</span>
                <span>|</span>
                <span class="class-number">{{ item.invite }}次约课</span>
              </div>
              <div class="line"></div>
              <p class="introduction">{{ item.introduction }}</p>
            </div>
          </div>
        </div>
        <Empty v-if="list.length == 0" class="empty" title="暂无讲师！" />
      </template>
    </List>
  </div>
</template>

<script>
import Classify from '../components/Classify.vue';
import List from '@/components/List.vue';
export default {
  name: 'ShowAppointmentTeachers',
  components: {
    Classify,
    List,
  },
  data() {
    return {
      classify: 0,
      subClassify: 0,
      grade_id: 0,
      subjects_id: 0,
      course_classify_id: 0,
      gradeList: [],
      classifyList: [],
      subjectList: [],
      date: '',
      pickerOptions: {
        disabledDate(v) {
          return v.getTime() < new Date().getTime() - 86400000;
        },
      },
      isLoaded: false,
    };
  },
  created() {
    if (this.$route.query.course_classify_id) {
      this.course_classify_id = this.$route.query.course_classify_id;
    }
    if (this.$route.query.grade_id) {
      this.grade_id = this.$route.query.grade_id;
    }
    if (this.$route.query.subjects_id) {
      this.subjects_id = this.$route.query.subjects_id;
    }
    this.init();
    this.getClassify();
  },
  computed: {
    classifyItems() {
      let items = [];
      if (this.gradeList.length > 0) {
        items.push({
          id: 'grade',
          name: '年级',
          value: { item: this.grade_id, child: this.subClassify },
          children: this.gradeList,
        });
      }
      if (this.classifyList.length > 0) {
        items.push({
          id: 'classify',
          name: '分类',
          value: { item: this.course_classify_id, child: this.subClassify },
          children: this.classifyList,
        });
      }
      items.push({
        id: 'subject',
        name: '科目',
        value: { item: this.subjects_id, child: this.subClassify },
        children: this.subjectList,
      });
      return items;
    },
    params() {
      let params = {
        start_time: this.date ? this.date[0] / 1000 : 0,
        end_time: this.date ? this.date[1] / 1000 : 0,
        grade_id: this.grade_id,
        subjects_id: this.subjects_id,
        course_classify_id: this.course_classify_id,
      };
      return params;
    },
  },
  methods: {
    onListLoad() {
      this.isLoaded = true;
    },
    init() {
      this.classify = 0;
      this.subClassify = 0;
    },
    async getClassify() {
      let data = await this.$http.get('/api/app/inviteTeacher/extra');
      if (data.grades.length > 0) {
        data.grades.unshift({ id: 0, name: '全部' });
      }
      data.subjects.forEach((item) => {
        item.name = item.sub_name;
      });
      data.subjects.unshift({ id: 0, name: '全部' });
      if (data.courseClassify.length > 0) {
        data.courseClassify.forEach((item) => {
          item.name = item.classify_name;
        });
        data.courseClassify.unshift({ id: 0, name: '全部' });
      }

      this.gradeList = data.grades;
      this.classifyList = data.courseClassify;
      this.subjectList = data.subjects;
    },
    onClassifyChange({ id, value }) {
      if (id == 'grade') {
        this.grade_id = value.item;
      } else if (id == 'classify') {
        this.course_classify_id = value.item;
      } else {
        this.subjects_id = value.item;
      }
      this.$refs.list.searchRefresh();
    },
    changDate() {
      this.$refs.list.searchRefresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.main-container {
  overflow: hidden;
}
.classify {
  margin: 0;
  margin-bottom: 16px;
  padding-bottom: 19px !important;
}
.classify-top {
  margin-top: 24px;
}
.class-date {
  display: flex;
  align-items: center;
  .label {
    color: #999999;
    font-size: 14px;
    margin-right: 13px;
    &:hover {
      color: $primary-color;
    }
  }
}
.teacher {
  width: 586px;
  height: 315px;
  box-sizing: border-box;
  float: left;
  background: rgba(255, 255, 255, 1);
  border-radius: 5px;
  display: flex;
  position: relative;
  cursor: pointer;
  margin-bottom: 34px;

  &:nth-child(2n + 1) {
    float: left;
  }

  &:nth-child(2n) {
    float: right;
  }

  &:hover {
    box-shadow: 0px 3px 15px 0px rgba(224, 224, 224, 1);

    .avatar {
      transform: scale(1.1);
    }

    // .name-wrap,
    // .marketing_language {
    //   top: -5px;
    // }

    // .introduction {
    //   top: 5px;
    // }
    .line {
      background: #fc5623;
    }
  }

  .right {
    width: 312px;
    box-sizing: border-box;
    padding-top: 32px;
  }

  .avatar-wrap {
    width: 210px;
    height: 100%;
    overflow: hidden;
    margin-right: 24px;
    border-radius: 6px;
    flex-shrink: 0;
    border: 1px solid #f3f3f3;
    position: relative;
    .avatar {
      width: 100%;
      height: 100%;
      border-radius: 6px;
      transition: all 0.3s;
    }
  }

  .name-wrap {
    display: flex;
    align-items: center;
    margin-bottom: 14px;
    overflow: hidden;
    position: relative;
    top: 0;
    transition: top 0.3s;
  }

  .name {
    font-size: 20px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 1.2;
  }

  .level {
    padding: 0 9px;
    height: 28px;
    box-sizing: border-box;
    background: rgba(237, 240, 247, 0);
    border: 1px solid rgba(202, 157, 59, 1);
    border-radius: 5px;
    line-height: 26px;
    font-size: 14px;
    color: rgba(213, 169, 75, 1);
    margin-left: 11px;
    flex-shrink: 0;
  }

  .marketing_language {
    height: 14px;
    font-size: 14px;
    color: #666666;
    line-height: 1;
    position: relative;
    top: 0;
    transition: top 0.3s;
    margin-bottom: 8px;
  }
  .career {
    display: flex;
    font-size: 14px;
    color: #666666;
    align-items: center;
    .class-time {
      margin-right: 8px;
    }
    .class-number {
      margin-left: 11px;
    }
  }
  .line {
    width: 24px;
    height: 3px;
    background: #ededed;
    border-radius: 1px;
    margin-top: 20px;
  }

  .introduction {
    height: 104px;
    font-size: 14px;
    color: rgba(153, 153, 153, 1);
    line-height: 26px;
    margin-top: 49px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    position: relative;
    top: 0;
    transition: top 0.3s;
  }

  .tag {
    position: absolute;
    width: 48px;
    height: 22px;
    background-image: url('~@/assets/images/oto/tea-tag@2x.png');
    background-size: 100% 100%;
    font-size: 14px;
    color: white;
    line-height: 22px;
    box-sizing: border-box;
    padding-left: 15px;
    top: 0;
    right: 0;
  }
}
.empty {
  margin-bottom: 70px;
}
.list {
  ::v-deep {
    .pager {
      margin: 12px 0 46px 0;
    }
  }
}
::v-deep .el-date-editor {
  width: 240px;
}
</style>
